<template>
  <tci-solution subtitle="工业智能制造与物联网" title="IoT" :images='$i18n.locale=="zh"?infos:infos_ja'></tci-solution>
</template>

<script>
import TciSolution from "@/components/TciSolution.vue";

export default {
  name: "CompanyService",
  components: {
    "tci-solution": TciSolution
  },
  data: () => ({
    infos: [{"imageUrl":require('../assets/solution/s3-1.jpg')},
    {"imageUrl":require('../assets/solution/s3-2.jpg')},
    {"imageUrl":require('../assets/solution/s3-3.jpg')},
    {"imageUrl":require('../assets/solution/s3-4.jpg')},
    {"imageUrl":require('../assets/solution/s3-5.jpg')},
    ],
     infos_ja: [{"imageUrl":require('../assets/solution/s3-1-ja.jpg')},
    {"imageUrl":require('../assets/solution/s3-2-ja.jpg')},
    {"imageUrl":require('../assets/solution/s3-3-ja.jpg')},
    {"imageUrl":require('../assets/solution/s3-4-ja.jpg')},
    {"imageUrl":require('../assets/solution/s3-5-ja.jpg')},
    ]
  })
};
</script>
